import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from "react";
import ModalSection from "@hl/base-components/lib/modal/ModalSection";
import { CLEAR_COLOR } from "@hl/base-components/lib/theme/button";
import { HIGHLIGHT_101_COLOR } from "@hl/base-components/lib/theme/colors";
import { Grid, Paper, Title, CloseButton, Text, Space, Modal, Button, Box, } from "@mantine/core";
import { getQuickStartPreference, setQuickStartPreference, } from "../../utils/quickStart";
import { useGetOnboardingConfigQuery } from "./queries.graphql.generated";
export const QuickStartContent = ({ content, sx }) => {
    const contentToRender = content.map((c) => (_jsxs("div", { children: [_jsxs(Box, { component: c.link ? "a" : "div", target: c.link ? "_blank" : "_self", href: c.link || "#", sx: sx, children: [_jsx(Text, { size: "md", weight: 500, children: c.title }), _jsx(Text, { size: "sm", children: c.description })] }), _jsx(Space, { h: "sm" })] }, c.id)));
    return _jsx(_Fragment, { children: contentToRender });
};
export const QuickStartBox = () => {
    const [showQuickStart, setShowQuickStart] = useState(false);
    const { data, loading } = useGetOnboardingConfigQuery();
    useEffect(() => {
        const preference = getQuickStartPreference();
        if (preference !== "dismissed")
            setShowQuickStart(true);
    }, []);
    const dismissQuickStart = () => {
        setQuickStartPreference(true);
        setShowQuickStart(false);
    };
    if (!showQuickStart)
        return _jsx(_Fragment, {});
    if (!data || loading)
        return _jsx(_Fragment, {});
    return (_jsxs(Paper, { p: "md", mb: "md", withBorder: true, sx: (theme) => ({
            backgroundColor: theme.fn.themeColor(HIGHLIGHT_101_COLOR.PRIMARY),
            borderColor: theme.fn.themeColor(HIGHLIGHT_101_COLOR.BORDER),
            color: theme.fn.themeColor(HIGHLIGHT_101_COLOR.TEXT),
        }), children: [_jsxs(Grid, { children: [_jsx(Grid.Col, { span: "auto", children: _jsx(Title, { weight: 500, size: 24, children: "Quick start guide" }) }), _jsx(Grid.Col, { span: "content", children: _jsx(CloseButton, { color: CLEAR_COLOR, "aria-label": "Dismiss", onClick: dismissQuickStart }) })] }), _jsx(Space, { h: "sm" }), _jsx(QuickStartContent, { content: data.getOnboardingConfig.guide })] }));
};
export const QuickStartModal = ({ isOpen, onClose }) => {
    const { data, loading } = useGetOnboardingConfigQuery();
    if (!data || loading)
        return _jsx(_Fragment, {});
    return (_jsxs(Modal, { size: "lg", opened: isOpen, onClose: onClose, title: _jsx(Text, { size: "lg", weight: 500, children: "Quick start guide" }), children: [_jsx(QuickStartContent, { content: data.getOnboardingConfig.guide }), _jsx(ModalSection, { children: _jsx(Button, { component: "a", size: "xl", fullWidth: true, href: "https://support.highlight.xyz/knowledge-base/get-started/deploy-a-contract", target: "_blank", children: "View more resources" }) })] }));
};
